<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" >
      <div class="modal" style="width: 100%; height: 100%;">

        <v-card
        style="position:fixed; top: 50%; left: 50%;transform: translate(-50%, -50%);">
          <v-card-title>

            </v-card-title>
            <v-card-text>
              {{message}}

                <v-layout row align-content-center>
                <v-flex
                    v-for="thumb in thumbs"  v-bind:key="thumb"
                >
                <img height="80px" :src="thumb" >
                </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                 <v-layout>
                <v-flex>

              <v-btn
              @click=onOK>
                OK
              </v-btn>
              <v-btn
              @click=onCancel>
                Cancel
              </v-btn>
                </v-flex>
                 </v-layout>
            </v-card-actions>
        </v-card>

      </div>
    </div>
  </transition>
</template>

<script>

export default {
  name: 'modal',
  data () {
    return {
      message: 'The following facees will be deleted:',
      faceIds: ['twdjg6rk']
    }
  },
  computed: {
    displayFaces () {
      return this.$store.getters['main/allfaces']
    },
    thumbs () {
      var thumbs = []
      for (var i = 0; i < this.faceIds.length; ++i) {
        if (this.faceIds[i] in this.displayFaces) {
          thumbs.push(this.displayFaces[this.faceIds[i]].thumb)
        }
      }
      return thumbs
    }
  },
  methods: {
    setFaceIds (faceIds) {
      this.faceIds = faceIds
    },
    setMessage (message) {
      this.message = message
    },
    onOK () {
      this.$emit('ok')
    },
    onCancel () {
      this.$emit('cancel')
    }
  },
  created: function () {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/CharacterPicker/CharacterWarning.vue